module.exports = __webpack_public_path__ + "img/account-connection.a07e14ac.png";